/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q2_QuestionInputs */

const en_faq_q2_question = /** @type {(inputs: Faq_Q2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where is my policy number?`)
};

const fr_faq_q2_question = /** @type {(inputs: Faq_Q2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où se trouve mon numéro de police ?`)
};

/**
* | output |
* | --- |
* | "Where is my policy number?" |
*
* @param {Faq_Q2_QuestionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_q2_question = /** @type {((inputs?: Faq_Q2_QuestionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q2_QuestionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q2_question(inputs)
	return fr_faq_q2_question(inputs)
});